import { UTCTimestamp } from "lightweight-charts";

export const massageData = (data: any[], valueField: string) => {
  const sortedData = data
    .filter((d) => d[valueField] !== null && d.timestamp)
    .sort((a: any, b: any) => a.timestamp.localeCompare(b.timestamp))
    .map((d) => ({
      time: (new Date(d.timestamp).getTime() / 1000) as UTCTimestamp,
      value: d[valueField],
    }));
  return sortedData.filter((d, i) => d.time !== sortedData[i - 1]?.time);
};

export const formatDate = (date: Date) => date.toLocaleDateString("fr-CA");
